import React from 'react';
import styled from 'styled-components';
import { colors } from 'constants/colors';
import Header from 'Components/landings/HeaderTransparent';
import { Flex, Box } from '@igooods/ui-kit';
import { IProductsGroup } from 'Modules/Shops/types';
import GroupsSlider from 'Components/landings/GroupsSlider';
import { mediaSmDown, mediaMdDown, mediaSmUp } from 'theme/helpers/css';
import AnimatedBg from './AnimatedBg';
import { useSpring } from 'react-spring';
import BlockTitle from 'Components/landings/BlockTitle';
import SearchAddress, { IGtagOptions } from 'Components/landings/LandingSearchAddress/SearchAddressBlock';
import { GtagFrom } from '../types';
import { IBlockWithDevice } from 'Components/landings/types';
import { EnumInputTheme } from 'constants/enums';

const Container = styled(Flex).attrs({ column: true })`
  background-color: ${colors.bananaFlavouredLemonade};
  min-height: 100vh;

  ${mediaSmDown`
    min-height: 100%;
  `}
`;

const Title = styled(BlockTitle)`
  ${mediaSmUp`
    text-align: center;
  `}
`;

const SAContainer = styled(Flex).attrs({ column: true, grow: true })`
  position: relative;
`;

const Description = styled(Box).attrs({ mt: { xs: 4.5, sm: 7 } })`
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  color: ${colors.blackRussian};

  ${mediaMdDown`
    font-size: 14px;
    line-height: 22px;
  `}

  ${mediaSmDown`
    text-align: left;
    width: 100%;
  `};
`;

const SearchAddressContainer = styled(Box).attrs({
  mt: { xs: 10, sm: 13.5, lg: 13.5 },
})`
  max-width: 580px;

  ${mediaMdDown`
    max-width: 540px;
  `}

  ${mediaSmDown`
    max-width: unset;
    width: 100%;
  `}
`;

const Content = styled(Flex).attrs({
  px: 5,
  pt: 2,
  pb: { xs: 10, sm: 20 },
  column: true,
  middle: true,
  center: true,
})`
  max-width: 666px;
  margin: 0 auto;
  flex: 1 1 auto;
  z-index: 3;

  ${mediaSmDown`
    justify-content: flex-start;
  `}
`;

interface IHeaderBanner extends IBlockWithDevice {
  groups?: IProductsGroup[];
}

const calc = (x: number, y: number) => [x - window.innerWidth / 2, y - window.innerHeight / 2];

const HeaderBanner: React.FC<IHeaderBanner> = ({ groups, device }) => {
  const [props, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }));

  const gtagOptions: IGtagOptions = {
    click_map_properties: { from: GtagFrom.MAIN },
    click_call_to_action_properties: { from: GtagFrom.MAIN, device },
  };

  return (
    <Container onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}>
      <SAContainer>
        <AnimatedBg animationProps={props} />
        <Header />
        <Content>
          <h1>
            <Title>Доставляем продукты из&nbsp;любимых магазинов</Title>
          </h1>
          <Description>
            <Box>Привозим в&nbsp;день заказа. Домой или в&nbsp;офис.</Box>
            Главное&nbsp;&mdash; внимательно выбираем продукты в&nbsp;магазине.
          </Description>
          <SearchAddressContainer>
            <SearchAddress use={EnumInputTheme.round} gtagOptions={gtagOptions} />
          </SearchAddressContainer>
        </Content>
      </SAContainer>
      <GroupsSlider groups={groups} />
    </Container>
  );
};

export default HeaderBanner;
